import { useMutation, useQueryClient } from "@tanstack/react-query";
import exploreCategoriesClient, {
  ExploreCategory,
} from "../../../api/explore-categories";

const useAddExploreCategoryMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["explore-categories"],
    mutationFn: (exploreCategory: Partial<ExploreCategory>) =>
      exploreCategoriesClient.createExploreCategory(exploreCategory),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: ["explore-categories"],
      }),
  });
};
export default useAddExploreCategoryMutation;
